<form class="" #setForm="ngForm" action="javascript:">
  <div class="row">
    <div class="col-sm-12">
      <app-card [title]="'admin.product.show.product information'|translate">
        <app-classic-box #classicForm [classicBox]="classicBox" [data]="lastValue"
                         (changeForm)="enableButton($event)"></app-classic-box>
        <br>
        <div>
          <div><strong>{{'doctrine.product.image'| translate }}</strong></div>
          <hr>
        </div>
        <div class="form-group row">
          <div [ngClass]="{'d-none':imageUrl}" class="form-group col-md-3">
            <label for="uploaderFile">{{'admin.product.file'| translate }}</label>
            <label class="custom-file">
              <input type="file" #uploadEl ng2FileSelect [uploader]="uploader" class="custom-file-input" id="uploaderFile" (change)="fileChange($event)" accept=".gif,.jpg,.jpeg,.png">
              <span class="custom-file-control-upload"
                    *ngIf="uploader.queue.length==0">{{"global.choose_file"|translate}}</span>
              <span class="custom-file-control-upload"
                    *ngIf="uploader.queue.length>0">{{"global.change_file"|translate}}</span>
              <span
                class="custom-file-control">{{(uploader.queue.length > 0) ? uploader.queue[uploader.queue.length - 1].file.name : ''}}</span>
            </label>
          </div>
          <div class="col-sm-1 p-0 text-center">
            <img class="product-img border" *ngIf="imageUrl" [src]="imageUrl" #imageElement>
          </div>
          <!--
          Change Button -->
          <div *ngIf="imageUrl" class="col-sm-2 pt-4">
            <button (click)="changeImage($event)"
                    class="btn btn-primary waves-effect waves-light text-nowrap me-2">{{'global.change_file'|translate}}</button>
            <!--
            Remove Image -->
            <button *ngIf="imageUrl != null" (click)="removeImage(lastValue.product.image, lastValue.product.id)"
                    type="button" class="btn btn-success waves-effect waves-light ">{{'global.delete_file'|translate}}
            </button>
          </div>
        </div>
        <div class="row">
          <!-- Loading Style -->
          <div class="preloader3 loader-block mx-auto" *ngIf="isUploading">
            <div class="circ1 loader-success"></div>
            <div class="circ2 loader-success"></div>
            <div class="circ3 loader-success"></div>
          </div>
        </div>
        <div class="card-block pull-right">
          <button (click)="redirectToList()" class="btn btn-link" type="button">{{'global.cancel'|translate}}</button>
          <button type="button" class="btn btn-primary ripple light"
                  [disabled]="isUploading || !setForm.valid || !enableSave"
                  (click)="submitItem(isEdit)">{{(isEdit ? 'global.save_changes' : 'global.add')|translate}}</button>
        </div>
      </app-card>
    </div>
  </div>
</form>

<app-modal-basic #productsModal [dialogClass]="'modal-lg'">
  <div class="app-modal-header">
    <h4 class="modal-title">{{'global.modal_title'|translate}}</h4>
    <button type="button" class="close basic-close" (click)="productsModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <app-grid [grid]="productsGrid" *ngIf="showModal"></app-grid>
  </div>
  <div class="app-modal-footer">
  </div>
</app-modal-basic>
